import { render, staticRenderFns } from "./insRole.vue?vue&type=template&id=fc8d28e6&"
import script from "./insRole.vue?vue&type=script&lang=js&"
export * from "./insRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports